<template>
  <div>
    <div>
      <template v-if="!validPostal">
        <span class="header">
          <icon
            icon="x-fa-exclamation-triangle"
            size="m"
          />
          Vul een kloppende postcode en huisnummer in.
        </span>
      </template>
      <template
        v-else-if="location && location.lookedUp && !location.data.address_found"
      >
        <span class="header">
          <icon
            icon="x-fa-exclamation-triangle"
            size="m"
          />
          We kunnen je postcode niet vinden, probeer opnieuw
        </span>
      </template>
      <template v-else-if="!loading">
        <span class="header">
          <icon
            icon="x-fa-info-circle"
            size="m"
          />
          Je postcode is nodig voor de juiste prijzen
        </span>
      </template>
      <template v-else-if="loading">
        <span class="header">
          <icon
            icon="x-fa-info-circle"
            size="m"
          />
          Checken...
        </span>
      </template>
    </div>
    <div class="sidebar-postal">
      <TextInput
        id="input-zip"
        v-model="inputZip"
        label="Postcode"
        lazy
      />
      <TextInput
        id="input-number"
        v-model="inputNumber"
        label="Nr"
        @keyup.enter="submit()"
      />
      <div class="postal-input">
        <k-button
          v-if="!loading"
          class="small-button"
          label="Check postcode"
          type="icon-right"
          icon="x-fa-long-arrow-right"
          @submit="submit()"
        />
        <k-button
          v-else
          class="small-button"
          type="no-icon"
        >
          <template #content>
            <svg
              width="33"
              height="24"
              viewBox="0 0 120 30"
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
            >
              <circle
                cx="15"
                cy="15"
                r="15"
              >
                <animate
                  attributeName="r"
                  from="15"
                  to="15"
                  begin="0s"
                  dur="0.8s"
                  values="15;9;15"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="fill-opacity"
                  from="1"
                  to="1"
                  begin="0s"
                  dur="0.8s"
                  values="1;.5;1"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="60"
                cy="15"
                r="9"
                fill-opacity="0.3"
              >
                <animate
                  attributeName="r"
                  from="9"
                  to="9"
                  begin="0s"
                  dur="0.8s"
                  values="9;15;9"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="fill-opacity"
                  from="0.5"
                  to="0.5"
                  begin="0s"
                  dur="0.8s"
                  values=".5;1;.5"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="105"
                cy="15"
                r="15"
              >
                <animate
                  attributeName="r"
                  from="15"
                  to="15"
                  begin="0s"
                  dur="0.8s"
                  values="15;9;15"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="fill-opacity"
                  from="1"
                  to="1"
                  begin="0s"
                  dur="0.8s"
                  values="1;.5;1"
                  calcMode="linear"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </template>
        </k-button>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from 'vue-elements/icon/Icon.vue';
import KButton from '../../../abstracts_depr/elements/button/button.vue';
import TextInput from '../input/TextInput.vue';

export default {
    components: {
        TextInput,
        Icon,
        KButton,
    },
    props: {
        loading: Boolean,
        location: {
            type: Object,
            default: () => {
            },
        },
    },
    emits: ['postal'],
    data() {
        return {
            inputZip: '',
            inputNumber: '',
            validPostal: true,
        };
    },
    watch: {
        location: {
            handler(newVal) {
                if (newVal) {
                    this.inputZip = newVal.data.postCode;
                    this.inputNumber = newVal.data.number;
                }
            },
            immediate: true,
            deep: true,
        },

    },
    methods: {
        submit() {
            if (this.inputZip.length > 4 && this.inputNumber.length > 0) {
                this.$emit('postal', {
                    postCode: this.inputZip,
                    nr: this.inputNumber,
                });
            } else {
                this.validPostal = false;
            }
        },
    },
};
</script>

<style lang="scss">
.sidebar-postal {
  display: grid;
  grid-template-columns: 3fr minmax(80px, 1fr);
  gap: 16px;

  button.cta.cta-icon-right {
    width: 100%;

    span.label {
      margin-bottom: 0px;
    }
  }

  .k-textfield {
    margin: 0;
  }
}

.postal-input {
  display: flex;
  justify-content: flex-end;
  grid-column: 1 / 3;
}
</style>
